export function getNodeClasses(node: any): string[] {
    const format = node.getFormat();
    const classes: string[] = [];
    if (format === 1) classes.push('dynamic-bold');
    if (format === 2) classes.push('dynamic-italic');
    if (format === 8) classes.push('dynamic-underline');

    return classes;
}
